import { setLocale } from "yup";

import { yupLocale } from "./yupLocale";

setLocale(yupLocale);

export * from "./validations";
export * from "yup";
